<router-outlet />

<div class="notifications-container">
  @for (notification of notificationService.notifications(); track notification.id) {
    <app-notification-box
      [message]="notification.message"
      [type]="notification.type"
      [floating]="true"
      [autoHide]="8000"
      (autoHidden)="onNotificationHidden(notification.id)"
    />
  }
</div>
